import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { IconType } from 'react-icons';
import * as FaIcons from 'react-icons/fa';
import { FullIconPicker } from '@/Domain/components/Shared/IconPicker/IconPicker';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/Domain/components/Shared/Popover/Popover';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/Domain/components/Shared/Tooltip/Tooltip';

type Props = {
  icon: string;
  color: string;
  canSelectIcon: boolean;
  onChange?: (name: string, color: string) => void;
};

export const ActionBoxIcon = ({ icon, color, onChange, canSelectIcon }: Props) => {
  const { t } = useTranslation('actions_page');

  // eslint-disable-next-line import/namespace
  const SelectedIcon = (FaIcons as Record<string, IconType>)[icon] as IconType | undefined;

  return (
    <div className="pb-0.5 shadow-sm size-11">
      <Popover open={canSelectIcon ? undefined : false}>
        <Tooltip open={canSelectIcon ? undefined : false}>
          <TooltipTrigger asChild>
            <PopoverTrigger asChild>
              <div
                data-testid="action-box-icon"
                className={classNames(
                  'flex size-11 !cursor-auto items-center justify-center rounded-lg bg-accent ring-1 ring-border ring-offset-2 ring-offset-card transition',
                  {
                    'hover:ring-foreground-subtle !cursor-pointer': canSelectIcon,
                  },
                )}
              >
                {SelectedIcon && <SelectedIcon size={20} color={color} />}
              </div>
            </PopoverTrigger>
          </TooltipTrigger>
          <TooltipContent>{t('tooltip.customize_icon')}</TooltipContent>
        </Tooltip>

        {onChange && (
          <PopoverContent className="w-auto p-4">
            <FullIconPicker iconName={icon} iconColor={color} onChange={onChange} />
          </PopoverContent>
        )}
      </Popover>
    </div>
  );
};
